import { Outlet, Link } from "react-router-dom";
import { AdminSidebar, AdminSidebarProvider } from "@/components/admin/AdminLayout";
import { useI18n } from "@/lib/i18n";

function AdminLayoutRoute() {
  const { t } = useI18n();
  return (
    <AdminSidebarProvider>
      <div className="flex min-h-screen bg-surface">
        <AdminSidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <Outlet />
        </div>
        <Link to="/" className="lg:hidden fixed bottom-4 right-4 rounded-full bg-foreground px-4 py-2 text-xs font-semibold text-background shadow-elevated">
          {t("admin.backToSite")}
        </Link>
      </div>
    </AdminSidebarProvider>
  );
}

export default AdminLayoutRoute;
